import { Translations } from './types';

export const es: Translations = {
  header: {
    about: 'Acerca de',
    ideas: 'Ideas',
    submitIdea: 'Comparte una idea',
    admin: 'Administración',
    logout: 'Cerrar sesión',
    loginSignUp: 'Iniciar sesión / Registrarse',
    loading: 'Cargando...',
  },
  footer: {
    contact: 'Contacto',
    quickLinks: 'Enlaces rápidos',
    needHelp: '¿Necesitas ayuda? Escríbenos a',
    allRightsReserved: 'Todos los derechos reservados.',
    privacyPolicy: 'Política de privacidad',
    evanstonDescription:
      'Putting Assets to Work (Poniendo los activos a trabajar): una iniciativa colaborativa de participación comunitaria para reimaginar y revitalizar los principales activos cívicos de Evanston, creando espacios vibrantes que sirvan a nuestra diversa comunidad.',
  },
  spaceSelector: {
    filterBySpace: 'Filtrar por espacio',
    allSpaces: 'Todos los espacios',
  },
  filterControls: {
    sortBy: 'Ordenar por',
    mostUpvoted: 'Más votadas',
    mostRecent: 'Más recientes',
    filterByTags: 'Filtrar por etiquetas',
    search: 'Buscar',
    clear: 'Borrar',
    clearAllTags: 'Borrar todas las etiquetas',
  },
  ideaCard: {
    anonymous: 'Anónimo',
    unknownUser: 'Usuario desconocido',
  },
  ideaForm: {
    successMessage: '¡Tu idea se envió con éxito! Gracias por tu contribución.',
    loginToSubmitTitle: 'Inicia sesión para compartir tu idea',
    loginToSubmitSubtitle: 'Inicia sesión o crea una cuenta para compartir tu idea.',
    backToForm: 'Volver al formulario',
    submitAsPrefix: 'Enviarás esta idea como',
    titleLabel: 'Título',
    titlePlaceholder: 'Escribe un título claro y descriptivo para tu idea',
    characters: 'caracteres',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Describe tu idea en detalle. ¿Qué implicaría? ¿Cómo beneficiaría a la comunidad?',
    selectSpace: 'Selecciona un espacio',
    chooseSpacePlaceholder: 'Elige a qué espacio corresponde esta idea',
    categoryTag: 'Etiqueta de categoría',
    selectTagPlaceholder: 'Selecciona una etiqueta para tu idea',
    anonymousTooltipOn:
      'Tu nombre quedará oculto para los demás usuarios, pero los administradores podrán ver quién envió esta idea.',
    anonymousTooltipOff: 'Haz clic para ocultar tu nombre a los demás usuarios',
    postingAnonymously: 'Publicando de forma anónima',
    postingAsPrefix: 'Publicando como',
    adminsCanSee: '(Los administradores aún pueden ver tu identidad)',
    addImageTitle: 'Agrega una imagen (opcional)',
    imageUploadFallback:
      'Agrega una representación visual de tu idea. Las imágenes ayudan a los demás a entender mejor tu visión. Formatos compatibles: JPEG, PNG, GIF, etc. (Tamaño máximo: 15 MB)',
    uploadImage: 'Subir imagen',
    compressingImage: 'Comprimiendo imagen...',
    remove: 'Quitar',
    submitIdea: 'Enviar idea',
    loginToSubmit: 'Inicia sesión para enviar',
    titleRequired: 'El título es obligatorio',
    descriptionRequired: 'La descripción es obligatoria',
    tagRequired: 'Por favor selecciona una etiqueta',
    spaceRequired: 'Por favor selecciona un espacio para tu idea',
    noSpaces: 'No hay espacios disponibles. Por favor contacta a soporte.',
    imageTooLarge: 'La imagen supera el límite de 15 MB. Por favor selecciona una imagen más pequeña.',
    invalidImage: 'Por favor selecciona un archivo de imagen válido (JPEG, PNG, etc.).',
    imageProcessFailed: 'No se pudo procesar la imagen. Por favor intenta con otra imagen.',
    submitFailed: 'No se pudo enviar tu idea. Por favor, inténtalo de nuevo.',
    tagsLoadFailed: 'No se pudieron cargar las etiquetas disponibles. Por favor actualiza la página e inténtalo de nuevo.',
    spacesLoadFailed: 'No se pudieron cargar los espacios disponibles. Por favor actualiza la página e inténtalo de nuevo.',
  },
  comments: {
    title: 'Conversación',
    noComments: 'Aún no hay comentarios. ¡Sé la primera persona en compartir su opinión!',
    loginToPostTitle: 'Inicia sesión para publicar tu comentario',
    loginToPostSubtitle: 'Inicia sesión o crea una cuenta para publicar tu comentario.',
    backToCommentForm: 'Volver al formulario de comentarios',
    addYourComment: 'Agrega tu comentario',
    postAsPrefix: 'Publicarás como',
    yourComment: 'Tu comentario',
    commentPlaceholder: 'Comparte tu opinión sobre esta idea...',
    commentEmpty: 'El comentario no puede estar vacío',
    submitFailed: 'No se pudo enviar el comentario. Por favor, inténtalo de nuevo.',
    commentingAnonymously: 'Comentando de forma anónima',
    commentingAsPrefix: 'Comentando como',
    anonymousTooltipOn:
      'Tu nombre quedará oculto para los demás usuarios, pero los administradores podrán ver quién publicó este comentario.',
    postComment: 'Publicar comentario',
    loginToPost: 'Inicia sesión para publicar',
  },
  ideaDetail: {
    backToIdeas: 'Volver a las ideas',
    postedOn: 'Publicado el',
    upvote: 'Votar',
    upvoted: 'Votado',
    ideaNotFound: 'Idea no encontrada.',
    visualizeIdea: 'Visualiza tu idea aquí',
  },
  dynamicAbout: {
    meetingsTitle: 'Reuniones comunitarias de PAW',
    past: 'Pasada',
    presentation: 'Presentación',
    notes: 'Notas',
    eventInfo: 'Información del evento',
    viewDetails: 'Ver detalles',
    downloadFlyer: 'Descargar folleto',
    loadFailed: 'No se pudo cargar el contenido',
    comingSoon: '¡Próximamente!',
  },
  documentGate: {
    signInTitle: 'Inicia sesión para acceder a estos documentos',
    signInSubtitle:
      'Debes iniciar sesión y aceptar los términos de divulgación de documentos antes de descargar los planos del proyecto y archivos CAD.',
    signIn: 'Iniciar sesión',
    signedNotice: 'Has firmado el acuerdo de divulgación de documentos. Las descargas están disponibles a continuación.',
  },
  loginForm: {
    loginTab: 'Iniciar sesión',
    signUpTab: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    fullName: 'Nombre completo',
    loginButton: 'Iniciar sesión',
    signUpButton: 'Registrarse',
    or: 'O',
    signInWithGoogle: 'Iniciar sesión con Google',
    signUpWithGoogle: 'Registrarse con Google',
    needAccount: '¿Necesitas una cuenta? Regístrate',
    haveAccount: '¿Ya tienes una cuenta? Inicia sesión',
    fullNameHelper: 'Obligatorio para registrarse con correo. Si te registras con Google, se usará tu nombre de Google.',
    passwordHelper: 'La contraseña debe tener al menos 6 caracteres',
    zipCode: 'Código postal',
    zipCodeHelper: 'Ingresa tu código postal de 5 dígitos',
    ward: 'Distrito (Ward)',
    wardPrefix: 'Distrito',
    unsure: 'No estoy seguro/a',
    wardOutside: 'Otro/Fuera de Evanston',
    address: 'Dirección',
    addressHelper: 'Opcional — nos ayuda a entender qué vecindarios están participando',
    raceEthnicity: 'Raza/Etnia',
    demographicDisclaimer:
      'La información recopilada aquí se utiliza únicamente para recoger opiniones de la comunidad sobre el futuro de los tres bienes públicos y los esfuerzos de planificación relacionados. No se utilizará para ningún otro propósito.',
    connectionToPrefix: 'Conexión con',
    pleaseSpecify: 'Por favor especifica',
    loggedIn: 'Sesión iniciada',
    loggedInAsPrefix: 'Sesión iniciada como',
    connectionPrefix: 'Conexión:',
    completeProfileTitle: 'Completa tu perfil',
    completeProfileHelpPrefix: 'Ayúdanos a entender tu conexión con el proyecto',
    completeProfileHelpSuffix: '.',
    updateProfileTitle: 'Actualizar perfil',
    completeProfileButton: 'Completar perfil',
    updateProfileButton: 'Actualizar perfil',
    continue: 'Continuar',
    logOut: 'Cerrar sesión',
    emailRequired: 'El correo electrónico es obligatorio',
    passwordRequired: 'La contraseña es obligatoria',
    passwordMinLength: 'La contraseña debe tener al menos 6 caracteres',
    fullNameRequired: 'El nombre completo es obligatorio',
    connectionRequiredPrefix: 'Por favor selecciona tu conexión con',
    connectionSpecifyPrefix: 'Por favor especifica tu conexión con',
    zipRequired: 'El código postal es obligatorio',
    zipFormat: 'El código postal debe ser un número de 5 dígitos',
    wardRequired: 'Por favor selecciona tu distrito',
    connectionBeforeGoogleSuffix: 'antes de registrarte con Google',
    zipBeforeGoogle: 'Por favor ingresa tu código postal antes de registrarte con Google',
    wardBeforeGoogle: 'Por favor selecciona tu distrito antes de registrarte con Google',
    raceEthnicityRequired: 'Por favor selecciona tu raza/etnia',
    raceEthnicitySpecifyRequired: 'Por favor especifica tu raza/etnia',
    raceEthnicityBeforeGoogle: 'Por favor selecciona tu raza/etnia antes de registrarte con Google',
    loginSuccess: '¡Sesión iniciada con éxito!',
    accountCreated: '¡Cuenta creada con éxito!',
    profileUpdated: '¡Perfil actualizado con éxito!',
    loggedOut: '¡Sesión cerrada con éxito!',
    loginFailed: 'No se pudo iniciar sesión. Por favor verifica tus credenciales.',
    signupFailed: 'No se pudo crear la cuenta. Por favor, inténtalo de nuevo.',
    googleSignInFailed: 'No se pudo iniciar sesión con Google. Por favor, inténtalo de nuevo.',
    googleSignUpFailed: 'No se pudo registrar con Google. Por favor, inténtalo de nuevo.',
    profileUpdateFailed: 'No se pudo actualizar el perfil. Por favor, inténtalo de nuevo.',
    logoutFailed: 'No se pudo cerrar la sesión. Por favor, inténtalo de nuevo.',
    mustBeLoggedIn: 'Debes iniciar sesión para actualizar tu perfil',
    forgotPassword: '¿Olvidaste tu contraseña?',
    resetEmailSent: 'Si existe una cuenta con ese correo, te enviamos un enlace para restablecer la contraseña. Revisa tu bandeja de entrada y la carpeta de spam.',
    resetFailed: 'No pudimos enviar el correo de restablecimiento. Por favor, inténtalo de nuevo.',
    authErrors: {
      invalidCredential: 'Correo o contraseña incorrectos. Verifica ambos, o usa "¿Olvidaste tu contraseña?" para restablecerla. Si te registraste con Google, usa el botón "Iniciar sesión con Google".',
      emailAlreadyInUse: 'Ya existe una cuenta con este correo. Por favor inicia sesión.',
      tooManyRequests: 'Demasiados intentos: esta cuenta está bloqueada temporalmente. Restablece tu contraseña o inténtalo más tarde.',
      invalidEmail: 'El correo electrónico no parece válido. Revisa si hay errores o espacios de más.',
      weakPassword: 'La contraseña es demasiado débil. Usa al menos 6 caracteres.',
      networkFailed: 'Error de red. Verifica tu conexión e inténtalo de nuevo.',
      popupClosed: 'La ventana de Google se cerró antes de terminar. Por favor, inténtalo de nuevo.',
      userDisabled: 'Esta cuenta ha sido deshabilitada. Contacta al equipo del sitio para recibir ayuda.',
    },
  },
  spaces: {
    'police-fire-station': {
      name: 'Estación de Policía y Bomberos',
      description: 'Ideas para la remodelación de las instalaciones de la estación de policía y bomberos',
    },
    'noyes-cultural-center': {
      name: 'Centro Cultural de Artes Noyes',
      description: 'Ideas para mejorar el Centro Cultural de Artes Noyes',
    },
    'civic-center': {
      name: 'Centro Cívico (Antigua Alcaldía)',
      description: 'Ideas para la transformación de la antigua alcaldía en un centro cívico',
    },
  },
  tags: {
    'Public Safety': 'Seguridad pública',
    'Arts & Culture': 'Arte y cultura',
    'Community Services': 'Servicios comunitarios',
    'Government Operations': 'Operaciones gubernamentales',
    'Public Spaces': 'Espacios públicos',
    'Accessibility': 'Accesibilidad',
    'Sustainability': 'Sostenibilidad',
    'Economic Development': 'Desarrollo económico',
    'Education': 'Educación',
    'Recreation': 'Recreación',
  },
  connectionOptions: {
    // Current affiliation list
    'Current Evanston resident': 'Residente actual de Evanston',
    'Former Evanston resident': 'Ex residente de Evanston',
    'Work in Evanston': 'Trabajo en Evanston',
    'Own a business in Evanston': 'Tengo un negocio en Evanston',
    'Attend a faith community in Evanston': 'Asisto a una comunidad de fe en Evanston',
    'Parent/guardian of an Evanston student': 'Padre/madre/tutor de un estudiante de Evanston',
    // Legacy stored values from earlier signups still need display translations
    'Resident of Evanston': 'Residente de Evanston',
    'Resident of surrounding communities': 'Residente de comunidades cercanas',
    'Regular visitor to Evanston': 'Visitante frecuente de Evanston',
    'Business owner in Evanston': 'Propietario/a de un negocio en Evanston',
    'Employee in Evanston': 'Empleado/a en Evanston',
    'Student at Northwestern University': 'Estudiante de Northwestern University',
    'Faculty/Staff at Northwestern University': 'Docente/Personal de Northwestern University',
    'Other': 'Otro',
  },
  raceEthnicityOptions: {
    'Black or African American': 'Negro o afroamericano',
    'White': 'Blanco',
    'Hispanic or Latino': 'Hispano o latino',
    'Asian': 'Asiático',
    'Native American or Alaska Native': 'Nativo americano o nativo de Alaska',
    'Native Hawaiian or Other Pacific Islander': 'Nativo de Hawái u otra isla del Pacífico',
    'Multiracial': 'Multirracial',
    'Prefer not to answer': 'Prefiero no responder',
    'Other': 'Otro',
  },
  home: {
    fallbackTitle: 'Ideas de la comunidad',
    fallbackSubtitle: 'Explora y vota por ideas para el desarrollo comunitario',
    upvoteAdded: '¡Voto agregado!',
    upvoteRemoved: 'Voto eliminado',
    upvoteFailed: 'No se pudo registrar tu voto. Por favor, inténtalo de nuevo.',
    loginToVote: 'Inicia sesión para votar por ideas',
  },
  submit: {
    fallbackTitle: 'Comparte tu idea',
    fallbackSubtitle: 'Comparte tu visión para el futuro de nuestro espacio comunitario.',
    fallbackProjectInfoTitle: 'Acerca de este proyecto',
    fallbackProjectInfoDescription: 'Una iniciativa comunitaria para transformar nuestro espacio.',
    fallbackLookingForTitle: 'Qué buscamos',
    fallbackLookingForDescription: 'Ideas creativas para espacios públicos y funciones comunitarias.',
    fallbackImpactTitle: 'Tu impacto',
    fallbackImpactDescription: 'La opinión de la comunidad es esencial para crear un espacio que refleje las necesidades locales.',
  },
  submissionWindow: {
    countdownLabel: 'Las ideas, los votos y los comentarios cierran en',
    days: 'días',
    hours: 'horas',
    minutes: 'minutos',
    seconds: 'segundos',
    closedTitle: 'Esta ronda de participación comunitaria está en pausa',
    closedBody: 'En este momento no estamos recibiendo nuevas ideas, votos ni comentarios. El equipo de Putting Assets to Work está revisando todo lo que la comunidad compartió y desarrollando recomendaciones para el Civic Center, el Noyes Cultural Arts Center y la sede de Policía y Bomberos. Habrá más oportunidades para opinar cuando el borrador de recomendaciones esté listo.',
    commentsClosed: 'Los comentarios están cerrados. En este momento no estamos recibiendo nuevos comentarios.',
    votes: 'votos',
  },
  common: {
    loading: 'Cargando...',
    error: 'Error',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
};
